const getFileExtension = (fileName: string): string => {
  const lastDotIndex = fileName.lastIndexOf('.');
  return fileName.substring(lastDotIndex);
};

const fileNameHasSubstring = (
  fileName: string,
  searchText: string
): boolean => {
  const lowerCaseFileName = fileName.toLowerCase();
  const lowerCaseSearchText = searchText.toLowerCase();
  return lowerCaseFileName.includes(lowerCaseSearchText);
};

const prepareIconsLinksToSave = (links: string): string[] => {
  let preparedLinks = [];
  preparedLinks = links.split(',').filter((v) => !!v);

  return preparedLinks;
};

const prepareIconsLinksToForm = (links: string[]): string => {
  return links.join(',');
};

export {
  getFileExtension,
  fileNameHasSubstring,
  prepareIconsLinksToSave,
  prepareIconsLinksToForm,
};
